// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ymu8","notes":"Notes_notes__10iZ-"};